import { useEffect, useState } from 'react'
import {
  GET_MESSAGE_DETAIL,
  GET_MESSAGE_LIST_PAGE,
  MSGPARAMS,
  MessageItem,
  NoticeItemRes,
} from '../../../api/orderManage'
import { PaginationOption } from '../../../global'
import { SUPROUTE } from '../../../route'
import { history } from '../../../redux/store'
import { isResponseCodeSuccess } from '../../../tools/util'

/**
 * 跳转订单详情页，根据type判断供应商详情和电商供应商详情
 * @param record
 */
export function jumpOrderDetail(record: {
  type: string
  supplierOrderId: string // type为7时是orderId，为1是供应商id
}) {
  let finalUrl = ''
  // 电商供应商订单通知
  if (record.type === '7') {
    finalUrl = `${SUPROUTE}/orderdetail?id=${record.supplierOrderId}`
    // 物料调价驳回，跳转至物料调价列表页
  } else if (record.type === '10') {
    finalUrl = `${SUPROUTE}/materialPriceAdjustment`
  } else if (record.type === '11') {
    // 询价单详情，使用询价单号跳转
    finalUrl = `${SUPROUTE}/inquiryDetail?id=${record.supplierOrderId}`
  } else if (record.type === '12') {
    // 询价单详情，使用询价单号跳转
    finalUrl = `${SUPROUTE}/inquiryDetail?id=${record.supplierOrderId}`
  } else if (record.type === '13') {
    // 询价单详情，使用询价单号跳转
    finalUrl = `${SUPROUTE}/inquiryDetail?id=${record.supplierOrderId}`
  } else if (record.type === '14') {
    // 物料审核通知（超期自动放弃），跳转至我的申请-物料申请列表
    finalUrl = `${SUPROUTE}/mylaunch?type=LAUNCHGOODS`
  } else {
    // 供应商
    finalUrl = `${SUPROUTE}/ordersupplierdetail?id=${record.supplierOrderId}`
  }
  history.push(finalUrl)
}
const initialPagenationOption = { pageNo: 1, pageSize: 5, totalCount: 100 }
export function useSetupHook() {
  const [dataSource, setDataSource] = useState<NoticeItemRes[]>([])
  const [spinning, setSpinning] = useState(true)
  const [paginationOption, setPaginationOption] = useState<PaginationOption>(
    initialPagenationOption,
  )
  const getNoticeInfo = async (params: MSGPARAMS) => {
    setSpinning(true)
    const res = await GET_MESSAGE_LIST_PAGE({ ...params })
    if (isResponseCodeSuccess(res.code)) {
      setDataSource(res.data.content)
      setPaginationOption({
        ...paginationOption,
        pageNo: params.pageNo,
        pageSize: params.pageSize,
        totalCount: paginationOption.totalCount,
      })
      setSpinning(false)
    }
  }
  const handleJumpMessageCenter = () => {
    history.push({
      pathname: `${SUPROUTE}/messageCenter`,
    })
  }
  const jumpOrderPage = async (record: MessageItem) => {
    const res = await GET_MESSAGE_DETAIL({ id: record.id })
    if (isResponseCodeSuccess(res.code)) {
      jumpOrderDetail({
        supplierOrderId: res.data.supplierOrderId,
        type: record.type,
      })
    }
  }

  useEffect(() => {
    getNoticeInfo({
      pageNo: initialPagenationOption.pageNo,
      pageSize: initialPagenationOption.pageSize,
    })
    // eslint-disable-next-line
  }, [])
  return {
    dataSource,
    handleJumpMessageCenter,
    jumpOrderPage,
    spinning,
  }
}
import { useEffect, useState } from 'react'
import {
  GET_MESSAGE_DETAIL,
  GET_MESSAGE_LIST_PAGE,
  MSGPARAMS,
  MessageItem,
  NoticeItemRes,
} from '../../../api/orderManage'
import { PaginationOption } from '../../../global'
import { SUPROUTE } from '../../../route'
import { history } from '../../../redux/store'
import { isResponseCodeSuccess } from '../../../tools/util'

/**
 * 跳转订单详情页，根据type判断供应商详情和电商供应商详情
 * @param record
 */
export function jumpOrderDetail(record: {
  type: string
  supplierOrderId: string // type为7时是orderId，为1是供应商id
}) {
  let finalUrl = ''
  // 电商供应商订单通知
  if (record.type === '7') {
    finalUrl = `${SUPROUTE}/orderdetail?id=${record.supplierOrderId}`
    // 物料调价驳回，跳转至物料调价列表页
  } else if (record.type === '10') {
    finalUrl = `${SUPROUTE}/materialPriceAdjustment`
  } else if (record.type === '11') {
    // 询价单详情，使用询价单号跳转
    finalUrl = `${SUPROUTE}/inquiryDetail?id=${record.supplierOrderId}`
  } else if (record.type === '12') {
    // 询价单详情，使用询价单号跳转
    finalUrl = `${SUPROUTE}/inquiryDetail?id=${record.supplierOrderId}`
  } else if (record.type === '13') {
    // 询价单详情，使用询价单号跳转
    finalUrl = `${SUPROUTE}/inquiryDetail?id=${record.supplierOrderId}`
  } else if (record.type === '14') {
    // 物料审核通知（超期自动放弃），跳转至我的申请-物料申请列表
    finalUrl = `${SUPROUTE}/mylaunch?type=LAUNCHGOODS`
  } else {
    // 供应商
    finalUrl = `${SUPROUTE}/ordersupplierdetail?id=${record.supplierOrderId}`
  }
  history.push(finalUrl)
}
const initialPagenationOption = { pageNo: 1, pageSize: 5, totalCount: 100 }
export function useSetupHook() {
  const [dataSource, setDataSource] = useState<NoticeItemRes[]>([])
  const [spinning, setSpinning] = useState(true)
  const [paginationOption, setPaginationOption] = useState<PaginationOption>(
    initialPagenationOption,
  )
  const getNoticeInfo = async (params: MSGPARAMS) => {
    setSpinning(true)
    const res = await GET_MESSAGE_LIST_PAGE({ ...params })
    if (isResponseCodeSuccess(res.code)) {
      setDataSource(res.data.content)
      setPaginationOption({
        ...paginationOption,
        pageNo: params.pageNo,
        pageSize: params.pageSize,
        totalCount: paginationOption.totalCount,
      })
      setSpinning(false)
    }
  }
  const handleJumpMessageCenter = () => {
    history.push({
      pathname: `${SUPROUTE}/messageCenter`,
    })
  }
  const jumpOrderPage = async (record: MessageItem) => {
    const res = await GET_MESSAGE_DETAIL({ id: record.id })
    if (isResponseCodeSuccess(res.code)) {
      jumpOrderDetail({
        supplierOrderId: res.data.supplierOrderId,
        type: record.type,
      })
    }
  }

  useEffect(() => {
    getNoticeInfo({
      pageNo: initialPagenationOption.pageNo,
      pageSize: initialPagenationOption.pageSize,
    })
    // eslint-disable-next-line
  }, [])
  return {
    dataSource,
    handleJumpMessageCenter,
    jumpOrderPage,
    spinning,
  }
}
